/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
  const primaryNavigation = document.getElementById("site-navigation");

  // Return early if the navigation don't exist.
  if (!primaryNavigation) {
    return;
  }

  const button = primaryNavigation.getElementsByTagName("button")[0];

  // Return early if the button don't exist.
  if ("undefined" === typeof button) {
    return;
  }

  const menu = primaryNavigation.getElementsByTagName("ul")[0];

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener("click", function () {
    primaryNavigation.classList.toggle("toggled");

    if (button.getAttribute("aria-expanded") === "true") {
      button.setAttribute("aria-expanded", "false");
    } else {
      button.setAttribute("aria-expanded", "true");
    }
  });

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener("click", function (event) {
    const isClickInside = primaryNavigation.contains(event.target);

    if (!isClickInside) {
      primaryNavigation.classList.remove("toggled");
      button.setAttribute("aria-expanded", "false");
    }
  });

  // Get all the link elements within the menu.
  const links = menu.getElementsByTagName("a");

  // Get all the link elements with children within the menu.
  const linksWithChildren = menu.querySelectorAll(".menu-item-has-children > a, .page_item_has_children > a");

  // Toggle focus each time a menu link is focused or blurred.
  for (const link of links) {
    link.addEventListener("focus", toggleFocus, true);
    link.addEventListener("blur", toggleFocus, true);
  }

  // Toggle focus each time a menu link with children receive a touch event.
  for (const link of linksWithChildren) {
    link.addEventListener("touchstart", toggleFocus, false);
  }

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus() {
    if (event.type === "focus" || event.type === "blur") {
      let self = this;
      // Move up through the ancestors of the current link until we hit .nav-menu.
      while (!self.classList.contains("nav-menu")) {
        // On li elements toggle the class .focus.
        if ("li" === self.tagName.toLowerCase()) {
          self.classList.toggle("focus");
        }
        self = self.parentNode;
      }
    }

    if (event.type === "touchstart") {
      const menuItem = this.parentNode;
      event.preventDefault();
      for (const link of menuItem.parentNode.children) {
        if (menuItem !== link) {
          link.classList.remove("focus");
        }
      }
      menuItem.classList.toggle("focus");
    }
  }
})();

/*--- Essentials Custom Nav JS ----*/
(function ($) {
  const $topNav = $("#site-navigation");

  $("#primary-nav-toggle").on("click", function (e) {
    let $button = $(this);
    $("body").toggleClass("menu-open");
    let expanded = $button.attr("aria-expanded") == "true";
    $button.next(".menu-main-menu-container").prop("hidden", !expanded);
  });

  $(".submenu-toggle").on("click", function (e) {
    let $button = $(this);
    // $('body').toggleClass('menu-open')
    let expanded = $button.attr("aria-expanded") == "true";
    $button.attr("aria-expanded", !expanded);
    // $button.next('.menu-main-menu-container').prop('hidden', !expanded);
    $button.parent(".menu-item").siblings().find("button").attr("aria-expanded", "false");
  });

  let closeMenu = function ($toggleButton, focusButton = false) {
    $toggleButton.attr("aria-expanded", false);
    $toggleButton.next(".menu-primary-menu-container").prop("hidden", true);
    $("body").removeClass("menu-open");
    if (focusButton) {
      $toggleButton.focus();
    }
    return this;
  };

  $topNav.on("keyup", function (e) {
    const ESC = 27;
    let $toggleButton = $(this).find("#primary-nav-toggle");
    let expanded = $toggleButton.attr("aria-expanded") == "true";
    if (!expanded) {
      return;
    }
    if (e.keyCode == ESC) {
      closeMenu($toggleButton, true);
    }
  });

  $topNav.find("#primary-menu").on("focusout", function (e) {
    let $navButton = $topNav.find("#primary-nav-toggle");
    if ($navButton.attr("aria-expanded") == "false") {
      return;
    }
    if ($(e.relatedTarget).parent().hasClass("menu-item") == false) {
      closeMenu($navButton, false);
    }
  });
})(jQuery);
